import script from "./LessonResourcesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonResourcesTab.vue?vue&type=script&setup=true&lang=js"

import "./LessonResourcesTab.vue?vue&type=style&index=0&id=0545b27e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0545b27e"]])

export default __exports__